//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TopFooterForm from '~/components/TopFooterForm.vue';
import BottomFooter from '~/components/BottomFooter.vue';
import TopFooterLinks from '~/components/TopFooterLinks.vue';
import DownloadAppIcons from '~/components/storyblok/DownloadAppIcons/DownloadAppIcons.vue';

const appIcons = {
  appleBranchLink: {
    url: 'https://fightcamp.app.link/y3nZxmYIDob',
    linktype: 'url',
    fieldtype: 'multilink',
    cached_url: 'https://fightcamp.app.link/y3nZxmYIDob',
  },
  googleBranchLink: {
    id: '',
    url: 'https://fightcamp.app.link/76ZCQs5IDob',
    linktype: 'url',
  },
  iconDimensions: {
    apple: {
      mobileHeight: '36px',
      tabletUpHeight: '48px',
    },
    google: {
      mobileHeight: '48px',
      tabletUpHeight: '66px',
    },
  },
};

export default {
  name: 'Footer',
  components: {
    BottomFooter,
    DownloadAppIcons,
    TopFooterForm,
    TopFooterLinks,
  },
  data() {
    return {
      appIconsData: appIcons,
    };
  },
};
